module.exports = __webpack_public_path__ + "static/media/mobilesense-urinehealth.118108c5.jpg";